import { Admission } from '@domain/admission';
import { formatCurrency } from '@utils/price-formatter/format-currency';

import { calculateOfflinePrice } from './calculate-offline-price';

export const formatOfflinePrice = ({ offer, quantity }: { offer: Admission; quantity: number }) => {
  let number = 0;
  number += calculateOfflinePrice({ offer, quantity });
  const currency = offer.price.currency;
  return formatCurrency({
    number,
    currency,
  });
};
